import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const DoorSVG: React.FunctionComponent<StyledProps> = (props) => {
  return (
    <StyledContainer {...props} data-testid="door-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 18 15"
        data-testid="door-svg"
      >
        <path
          fill="#070B16"
          fillRule="evenodd"
          d="M16.5 6.581H2.35l3.666-3.972c.545-.59 1.828-1.147 2.641-1.147H16.5v5.119zm-3 2.925h3V8.044h-3v1.462zM8.657 0C7.42 0 5.73.734 4.902 1.631L.66 6.225c-.552.598-.81 1.717-.573 2.489l1.388 4.51c.237.77 1.106 1.401 1.932 1.401H16.5c.83 0 1.5-.655 1.5-1.463V0H8.657z"
        />
      </svg>
    </StyledContainer>
  );
};

export default DoorSVG;
